// Integers at or above this boundary get comma-separated formatting.
const COMMA_FORMAT_THRESHOLD = 1000;

/**
 * Formats numbers with commas only if they exceed 3 digits
 * @param {number|string} value - The number to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} - Formatted number with commas if > 3 digits
 */
export const formatLargeNumbers = (value, decimals = 2) => {
  if (value === null || value === undefined || value === '') {
    return '0';
  }

  const numValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numValue)) {
    return value.toString();
  }

  const absValue = Math.abs(numValue);
  const integerPart = Math.floor(absValue);

  if (integerPart >= COMMA_FORMAT_THRESHOLD) {
    return numValue.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  // For numbers less than 1000, just format with decimals
  return numValue.toFixed(decimals);
};
